import { TBankAccount } from '@/utils/tools/IBAN/IBAN.types';

export const IBAN_FR_REGEX = /^FR(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})/;
export const IBAN_DE_REGEX = /^DE(\d{2})(\d{8})(\d{10})/;
export const IBAN_ES_REGEX = /^ES(\d{2})(\d{4})(\d{4})(\d{2})(\d{10})/;
export const IBAN_IT_REGEX = /^IT(\d{2})([\d\w])(\d{5})(\d{5})(\d{12})/;
export const IBAN_ALL_REGEX = /^(\w{2})(\d{2})([\d\w]{15,34})/;
export const IBAN_REGEX = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/;

export function isValidIBAN(iban: string): boolean {
  return IBAN_REGEX.test(iban);
}

export function extractWalletIdFromIBAN_FR(iban: string): TBankAccount | null {
  if (IBAN_FR_REGEX.test(iban)) {
    const match = iban.match(IBAN_FR_REGEX);
    return {
      iban,
      country: 'FR',
      bankCode: match[1],
      agencyCode: match[2],
      sortCode: match[3],
      accountNumber: match[4],
      controlKey: match[5],
      walletId: parseInt(match[4]),
    };
  } else {
    return null;
  }
}

export function extractWalletIdFromIBAN_DE(iban: string): TBankAccount | null {
  if (IBAN_DE_REGEX.test(iban)) {
    const match = iban.match(IBAN_DE_REGEX);
    return {
      iban,
      country: 'DE',
      bankCode: match[1],
      agencyCode: match[2],
      accountNumber: match[3],
      walletId: parseInt(match[3]),
    };
  } else {
    return null;
  }
}

export function extractWalletIdFromIBAN_ES(iban: string): TBankAccount | null {
  if (IBAN_ES_REGEX.test(iban)) {
    const match = iban.match(IBAN_ES_REGEX);
    return {
      iban,
      country: 'ES',
      bankCode: match[1],
      agencyCode: match[2],
      sortCode: match[3],
      controlKey: match[4],
      accountNumber: match[5],
      walletId: parseInt(match[5]),
    };
  } else {
    return null;
  }
}

export function extractWalletIdFromIBAN_IT(iban: string): TBankAccount | null {
  if (IBAN_IT_REGEX.test(iban)) {
    const match = iban.match(IBAN_IT_REGEX);
    return {
      iban,
      country: 'IT',
      bankCode: match[2],
      agencyCode: match[3],
      sortCode: match[4],
      controlKey: match[1],
      accountNumber: match[5],
      walletId: parseInt(match[5]),
    };
  } else {
    return null;
  }
}

export function extractWalletIdFromIBAN_ALL(iban: string): TBankAccount | null {
  if (IBAN_ALL_REGEX.test(iban)) {
    const match = iban.match(IBAN_ALL_REGEX);
    return {
      iban,
      country: match[0],
      bankCode: match[1],
      walletId: null,
    };
  } else {
    return null;
  }
}

export function isIBAN(iban: string): boolean {
  return extractWalletIdFromIBAN(iban) !== null;
}

export function extractWalletIdFromIBAN(iban: string | null | undefined): TBankAccount | null {
  if (!iban) return null;
  switch (iban.slice(0, 2)) {
    case 'FR':
      return extractWalletIdFromIBAN_FR(iban);
    case 'DE':
      return extractWalletIdFromIBAN_DE(iban);
    case 'ES':
      return extractWalletIdFromIBAN_ES(iban);
    case 'IT':
      return extractWalletIdFromIBAN_IT(iban);
    default:
      return extractWalletIdFromIBAN_ALL(iban);
  }
}
